import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M1 10l5 5v-4.25l13 .0074V9.25H6V5z'],
  height: 20,
  width: 20,
});
